import { render, staticRenderFns } from "./AssignTask.vue?vue&type=template&id=72c18a99&scoped=true"
import script from "./AssignTask.vue?vue&type=script&lang=js"
export * from "./AssignTask.vue?vue&type=script&lang=js"
import style0 from "./AssignTask.vue?vue&type=style&index=0&id=72c18a99&prod&lang=scss"
import style1 from "./AssignTask.vue?vue&type=style&index=1&id=72c18a99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c18a99",
  null
  
)

export default component.exports